import {Pipe, PipeTransform} from '@angular/core';
import * as getISODay from 'date-fns/get_iso_day';
import {TimecardRateType} from "../../model";

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

@Pipe({name: 'timecardInterval'})
export class TimecardIntervalPipe implements PipeTransform {

  transform(timecard: TimecardDetails, dayOfWeek?: number): TimeInterval[] {
    if (timecard.rateTypeId === TimecardRateType.DAILY) {
      return [];
    }
    if (!timecard.useDtr) {
      const prefix = DAYS[dayOfWeek - 1];
      const interval: TimeInterval = {
        startTime: timecard[prefix + 'TimeIn'],
        endTime: timecard[prefix + 'TimeOut'],
        lunchTime: timecard[prefix + 'TimeLunch'],
        totalHours: timecard[prefix + 'TimeTotal']
      };
      return interval.totalHours ? [interval] : [];
    }
    return timecard.timeIntervalList
      .filter(v => getISODay(v.startTime) === dayOfWeek);
  }
}
